module.exports = "/data-files/us-states.json";


//////////////////
// WEBPACK FOOTER
// ./src/data-files/us-states.json
// module id = 487
// module chunks = 0